<template>
    <div class="container">
        <div>
            <div class="heading" >
                Withdrawal Status
            </div>
            <figure>
                <v-icon
                    class="material-icons-round transactionIconsWithdraw large" v-if="selectedWithdrawal.status === 'cancelled'">
                    cancel
                </v-icon>
                <img v-else-if="this.selectedWithdrawal.isActiveWithdrawal" src="/img/yellowClock.svg" alt="Pending" style="margin-top: 36px">
                <img v-else src="/img/check-circle-green.svg" alt="Pending" style="margin-top: 36px; height: 42px;">
            </figure>
            <div class="amount">
                &#x20B9;{{ this.selectedWithdrawal.amount | localeAmountPaisa}}
            </div>
            <div class="portfolio">
                {{ this.selectedWithdrawal.planType | capitalize }} {{ this.selectedWithdrawal.riskProfile | capitalize }}
            </div>
        </div>
        <div class="dashedLines">
        </div>
        <div>
            <div class="steps">
                <figure>
                    <img src="/img/check-circle-green.svg" alt="">
                </figure>
                <div class="stepTitle">
                    <div class="stepHeading">
                        Redeem order placed
                    </div>
                    <div class=" stepSubheading">
                        {{ this.selectedWithdrawal.createdAt | customFormatDate }}
                    </div>
                </div>
                <div class="dashedLines vertical"></div>
            </div>

            <div class="steps">
                <figure>
                    <img src="/img/check-circle-green.svg" alt="">
                </figure>
                <div class="stepTitle">
                    <div class="stepHeading">
                        Redeem order received
                    </div>
                    <div class="stepSubheading">
                        {{ this.selectedWithdrawal.createdAt| customFormatDate }}
                    </div>
                </div>
                <div class="dashedLines vertical"></div>
            </div>

            <div class="steps" v-if="selectedWithdrawal.status === 'cancelled'">
                <figure>
                    <v-icon
                        class="material-icons-round transactionIconsWithdraw">
                        cancel
                    </v-icon>
                </figure>
                <div class="stepTitle">
                    <div class="stepHeading">
                        Cancelled
                    </div>
                    <div class="stepSubheading">
                        {{ selectedWithdrawal.requestCancelDate | customFormatDate}}
                    </div>
                </div>
            </div>

            <div class="steps" v-if="selectedWithdrawal.status !== 'cancelled' && !selectedWithdrawal.closeDate">
                <figure >
                    <img style="width: 20px; height: 20px;" src="/img/yellowClock.svg" alt="">
                </figure>
                <div class="stepTitle">
                    <div class="stepHeading">
                        In process
                    </div>
                    <div class="stepSubheading">
                        {{ new Date() | customFormatDate }}
                    </div>
                </div>
                <div class="dashedLines vertical"></div>
            </div>

            <div class="dashedLine"></div>
            <div class="steps" v-if="selectedWithdrawal.status !== 'cancelled'">
                <figure>
                    <img v-if="!selectedWithdrawal.closeDate" src="/img/clock-gray.svg" alt="">
                    <img v-else src="/img/check-circle-green.svg" alt="Pending">
                </figure>
                <div class="stepTitle">
                    <div class="stepHeading">
                        Delivered
                    </div>
                    <div class="stepSubheading">
                        {{ getDeliveryDate | customFormatDate}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WithdrawalRequestSubmitted',
    components: {
    },
    props: {
        selectedWithdrawal: {
            type: Object
        }
    },
    data () {
        return {
            step: 1,
            portfolios: [
                {
                    portfolioId: '61c34e682d1a640008db2b1f',
                    planType: 'growth',
                    riskProfile: 'aggressive',
                    amount: 1209912,
                    transactionDate: '2021-12-10T11:58:02.441Z',
                    expectedDate: '2023-01-01'
                }
            ]
        }
    },
    computed: {
        getDeliveryDate () {
            return this.selectedWithdrawal.closeDate ? this.selectedWithdrawal.closeDate : this.selectedWithdrawal.expectedDate
        }
    }
}
</script>

<style scoped lang="scss">
    .heading {
        font-weight: 600;
        font-size: 21px;
        line-height: 21px;
        color: #6A6A6A;
    }

    .amount {
        font-size: 28px;
        color: #232323;
        font-weight: 700;
        padding: 12px 0px;
    }

    .portfolio {
        font-size: 17px;
        color: #4F4F4F;
        font-weight: 500;
    }

    .steps {
        display: flex;
        align-items: center;
        margin-bottom: 50px;
        margin-top: 24px;
        position: relative;
        .stepTitle {
            padding-left: 12px;
        }
        .stepHeading {
            font-size: 13px;
        }

        .stepSubheading {
            color: #868E96;
            font-size: 11px;
        }
    }

    .dashedLines {
        border: 0.6px dashed rgba(0, 0, 0, 0.3);
        flex: none;
        order: 1;
        flex-grow: 0;
        margin-top: 12px;
    }

    .transactionIconsWithdraw {
        color: #c20000;
        font-size: 21px !important;
    }

    .large {
        margin-top: 24px;
        font-size: 42px !important;
    }

    figure {
        z-index: 1;
    }
    .vertical {
        position: absolute;
        transform: rotate(90deg) !important;
        width: 78px;
        left: -30px;
        top: 45px;
    }
</style>
